export default __webpack_public_path__ + "static/celebration-8da6b27f01eada823840a1ff60c14859.webp";